import { IconChevronRight } from '@tabler/icons-react-native'
import { map } from 'lodash'
import { type FC } from 'react'

import { Box, Pressable, Text, VStack } from '@/components'
import { COLOR_WHITE } from '@/lib'

export interface GetToKnowMeFieldProps {
  items: { question: string; answer: string }[]
  onPress: () => void
  isDisabled?: boolean
  testID?: string
}

export const GetToKnowMeField: FC<GetToKnowMeFieldProps> = ({ items, onPress, isDisabled, testID }) => (
  <Pressable
    accessible
    accessibilityLabel={
      items.length
        ? `Get to Know Me. ${map(items, (item) => `${item.question}: ${item.answer}`).join('. ')}. Tap to edit.`
        : 'Get to Know Me. Tap to add prompts to your profile.'
    }
    accessibilityRole='button'
    disabled={isDisabled}
    onPress={onPress}
    testID={testID}
  >
    <VStack className='gap-3'>
      <Box className='flex-row items-center justify-between'>
        <Text
          className='font-poppinsSemiBold color-white'
          size='lg'
        >
          Get to Know Me
        </Text>
        <IconChevronRight
          color={COLOR_WHITE}
          size={20}
        />
      </Box>
      {items.length > 0 ? (
        <VStack className='gap-3'>
          {map(items, (item, index) => (
            <VStack
              className='gap-1 rounded-xl bg-white/20 px-3 py-2'
              key={index}
            >
              <Text className='font-poppinsSemiBold color-white'>{item.question}</Text>
              <Text className='font-poppinsRegular text-white'>{item.answer}</Text>
            </VStack>
          ))}
        </VStack>
      ) : (
        <Text className='font-poppinsRegular opacity-60 color-white'>Tap to add prompts to your profile</Text>
      )}
    </VStack>
  </Pressable>
)
